import VolumeLevel from "./call/VolumeLevel";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const ActiveCallDetail = ({ volumeLevel, onEndCallClick }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "150px",
      }}
    >
      <VolumeLevel volume={volumeLevel} />
      <Box sx={{ textAlign: "center", width: "100%" }}>
        {/* Default MUI button with 'error' color for Hang Up */}
        <Button
          variant="contained"
          color="error" // Use MUI's error color for danger (red)
          onClick={onEndCallClick}
          fullWidth
        >
          Hang Up
        </Button>
      </Box>
    </Box>
  );
};

export default ActiveCallDetail;
